export default __webpack_public_path__ + "static/media/queenbee.d12237e9.jpg";